import React from "react";
import { cls } from "shared/lib/util/classnames";

interface Props {
  label: {
    id:
      | "isRestaurant"
      | "isSnack"
      | "isParking"
      | "isWaitingRoom"
      | "isHandicapped";
    name: string;
  };
  isSelected: boolean;
  onClick: (
    id:
      | "isRestaurant"
      | "isSnack"
      | "isParking"
      | "isWaitingRoom"
      | "isHandicapped",
  ) => void;
}

export function FacilitySelectBtn({ label, isSelected, onClick }: Props) {
  return (
    <div
      onClick={() => onClick(label.id)}
      className={cls(
        isSelected ? "bg-black text-white" : "bg-[#f0f0f0] text-[#9b9b9b]",
        "cursor-pointer rounded-[30px] px-[35px] py-[12px] text-[18px] font-semibold",
      )}
    >
      {label.name}
    </div>
  );
}
